export default {
  PERSONAL_INFO_REPOSITORY: Symbol.for('PERSONAL_INFO_REPOSITORY'),
  GET_PERSONAL_INFO_QUERY: Symbol.for('GET_PERSONAL_INFO_QUERY'),
  PERSONAL_INFO_STATE_MANAGER: Symbol.for('PERSONAL_INFO_STATE_MANAGER'),
};
